import React from 'react';

import {
  Router,
  Route,
  IndexRoute,
  browserHistory,
} from 'react-router';

import Main from 'containers/Main';
import Landing from 'containers/Landing';
import FieldSubmission from 'containers/FieldSubmission';
import SubmitSuccess from 'containers/SubmitSuccess';
import Login from 'containers/Login';
import ForgotPassword from 'containers/ForgotPassword';
import ResetPassword from 'containers/ResetPassword';
import Admin from 'containers/Admin';

import './App.scss';

const requireAuth = (nextState, replace) => {
  if (!localStorage.getItem('token')) {
    replace('/login');
  }
}

const scrollUp = (prevState, nextState) => {
  document.body.scrollTop = 0;
}

export default class App extends React.Component {
  render () {
    return (
      <Router history={browserHistory}>
        <Route path="/" component={Main} onChange={scrollUp}>
          <IndexRoute component={Landing} />
          <Route path="entry" component={FieldSubmission} />
          <Route path="success" component={SubmitSuccess} />
          <Route path="login" component={Login} />
          <Route path="forgot" component={ForgotPassword} />
          <Route path="reset/:token" component={ResetPassword} />
          <Route path="admin" component={Admin} onEnter={requireAuth} />
        </Route>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js